import React from "react";

type Props = {
  status: string;
};

export class OrderStatus extends React.Component<Props> {
  render() {
    switch (this.props.status) {
      case "WAITING":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Need to prepare
          </span>
        );
      case "ORDERING":
        return (
          <span
            className="alert alert-primary"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Ordering
          </span>
        );
      case "DELIVERED":
        return (
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Delivered
          </span>
        );
      case "READY":
        return (
          <span
            className="alert alert-success"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Ready
          </span>
        );
      case "FINDING":
        return (
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Finding
          </span>
        );
      case "OOS":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Out Of Stock
          </span>
        );
      case "INSTORE_PURCHASE":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Instore Purchase
          </span>
        );
      case "RETURNING":
        return (
          <span
            className="alert alert-danger"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Returning
          </span>
        );
      case "UNCOLLECTED":
        return (
          <span
            className="alert alert-danger"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Uncollected
          </span>
        );
      case "RETURNED":
        return (
          <span
            className="alert alert-success"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Returened
          </span>
        );
      case "FOUND":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Found
          </span>
        );
      case "PREPARED":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Prepared
          </span>
        );
      case "ARRIVED_AT_AGENT":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Agent Arrived
          </span>
        );
      case "MERCHANT_SHIPPED":
        return (
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Merchant Shipped
          </span>
        );
      case "ARRIVED_AT_SHIPPER":
        return (
          <span
            className="alert alert-warning"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Shipper Sent
          </span>
        );
      case "ARRIVED":
        return (
          <span
            className="alert alert-success"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Arrived
          </span>
        );
      case "DAMAGED_ITEM":
        return (
          <span
            className="alert alert-danger"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Damaged Item
          </span>
        );
      case "WRONG_ITEM":
        return (
          <span
            className="alert alert-danger"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Wrong Item
          </span>
        );
      case "MERCHANT_CANCELLED":
        return (
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Merchant Cancelled
          </span>
        );
      case "DISCONTINUED":
        return (
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Discountined
          </span>
        );
      case "REQUEST_PICKUP":
        return (
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Request Pickup
          </span>
        );
      case "DEPARTED":
        return(
          <span
            className="alert alert-info"
            style={{
              padding: 6,
              fontSize: 11,
              borderRadius: "0 0 5px 5px",
              width: 105,
              display: "inline-block",
              borderStyle: "none",
            }}
          >
            Departed
          </span>
        )
    }
  }
}
